import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import OtpInput from 'react-otp-input';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Apis from '../../api';
import { RootState } from '../../store/rootReducer';
import HSButton from '../common/Button';
import { RequiredLayout } from '../main/resignAgreements/PostAgreements';
import MessageActions from '../message/redux/actions';
import LoginActions from './redux/actions';
import { getRedirectUrlAfterLogin } from './utils';
import { UserStatus } from './utils/Status';

const AccountActivationWithOTP: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [otp, setOtp] = useState('');
    const [isValidate, setIsValidate] = useState(false);
    const [counter, setCounter] = useState(0);
    const [sendOtpLoader, setSendOTPLoader] = useState(false);
    const [loader, setLoader] = useState(false);

    const email = useSelector((state: RootState) => state.user.user?.email);
    const userStatus = useSelector((state: RootState) => state.user.user?.status);
    const user = useSelector((state: RootState) => state.user);

    useLayoutEffect(() => {
        if (userStatus && userStatus === UserStatus.active) {
            navigate(getRedirectUrlAfterLogin(user, undefined));
        }
    }, [userStatus, navigate, user]);

    const handleChange = (otp: any) => {
        setOtp(otp);
    };

    const onClickVerify = () => {
        setIsValidate(true);
        if (otp.length !== 4) {
            return;
        }
        setIsValidate(false);
        setLoader(true);
        Apis.verifyOTP({
            token: otp,
        })
            .then(({ data }) => {
                dispatch(LoginActions.updateUserProfile(data));
                navigate(getRedirectUrlAfterLogin(user, undefined));
            })
            .catch((err) => {
                dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
            })
            .finally(() => {
                setLoader(false);
            });
    };

    const sendOTP = useCallback(() => {
        if (email) {
            setSendOTPLoader(true);
            Apis.sendOTP({ email })
                .then(() => {
                    setCounter(30);
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
                })
                .finally(() => {
                    setSendOTPLoader(false);
                });
        }
    }, [email, dispatch]);

    useEffect(() => {
        if (userStatus && userStatus === UserStatus.pendingActivation) {
            sendOTP();
        }
    }, [sendOTP, userStatus]);

    useEffect(() => {
        const timer = setInterval(() => setCounter(counter - 1), 1000);
        if (counter <= 0) {
            clearInterval(timer);
        }
        return () => clearInterval(timer);
    }, [counter]);

    return (
        <RequiredLayout>
            <div className="flex justify-center items-center flex-col">
                <p className="text-[#20222B]  text-center text-lg WorkSans-Semibold">Activate your account</p>
                <p className="text-center py-2 text-[#26AE60]">
                    An OTP has been sent to your email. Please check and key in below.
                </p>
                <div className="flex justify-start pt-4 flex-col">
                    <p className="pb-4 WorkSans text-[#20222B]">Enter OTP</p>
                    <OtpInput
                        value={otp}
                        onChange={handleChange}
                        numInputs={4}
                        separator={<span>&nbsp;</span>}
                        inputStyle={{ width: '3rem', height: '3rem', marginRight: '1rem' }}
                    />
                    {isValidate && otp.length < 4 && <p className="common_error pt-2">Please enter otp</p>}
                </div>
                <div className="pt-4">
                    {counter > 0 && (
                        <p className="text-[#B1C1D4]">
                            Resend OTP: <span className="text-[#20222B]">&nbsp;00:{`0${counter}`.slice(-2)}</span>
                        </p>
                    )}
                    {counter === 0 && (
                        <HSButton
                            title="Resend OTP"
                            className="mt-4"
                            onClick={sendOTP}
                            type="link"
                            loading={sendOtpLoader}
                        />
                    )}
                </div>
                <div className="flex justify-center pt-4">
                    <HSButton title="VERIFY" type="primary" onClick={onClickVerify} loading={loader} />
                </div>
            </div>
        </RequiredLayout>
    );
};

export default AccountActivationWithOTP;
